var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic/create"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 816708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 816716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10.201C19 15.4478 14.7467 19.701 9.5 19.701C4.25329 19.701 0 15.4478 0 10.201C0 4.95434 4.25329 0.70105 9.5 0.70105C14.7467 0.70105 19 4.95434 19 10.201ZM9.53499 5.57882C9.97222 5.57882 10.3267 5.93326 10.3267 6.37048V9.44438H13.4005C13.8377 9.44438 14.1921 9.79882 14.1921 10.236C14.1921 10.6733 13.8377 11.0277 13.4005 11.0277H10.3267V14.1015C10.3267 14.5387 9.97222 14.8932 9.53499 14.8932C9.09777 14.8932 8.74333 14.5387 8.74333 14.1015V11.0277H5.66943C5.23221 11.0277 4.87777 10.6733 4.87777 10.236C4.87777 9.79882 5.23221 9.44438 5.66943 9.44438H8.74333V6.37048C8.74333 5.93326 9.09777 5.57882 9.53499 5.57882Z",
    fill: "currentColor"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.66a7773d51c282d9a3a9bde138308d4f.svg";
export { ForwardRef as ReactComponent };